import * as types from './types';
import actions from './actions';
import {
  extend,
} from 'lodash';

const state = {
  //供应商管理列表
  supplierManageList:{
    state: '',
    list: [],
    total: 0,
  },

};

const getters = {
  //供应商管理列表
  getSupplierManageList: (state) => state.supplierManageList,

};

const mutations = {
  //供应商管理列表
  [types.ACTION_SUPPLIER_MANAGE_LIST_PORT]({supplierManageList}, result){
    extend(supplierManageList, result);
  },

};


export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/Admin/modules/supplierManage/index.js